module.exports = __webpack_public_path__ + "img/main.126816f6.png";